var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"lead"},[_c('h1',{staticClass:"title"},[_vm._v("Qué?")]),_vm._m(0),_c('router-link',{staticClass:"button is-link",attrs:{"to":"/"}},[_vm._v("Back to Dashboard")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"subtitle"},[_vm._v("Sorry, I couldn't find what"),_c('br'),_vm._v("you were looking for.")])
}]

export { render, staticRenderFns }